import {
  handleFileUpload,
  handleFilterTypes,
  handleGetFiles,
  handleImportCards,
  handleImportDeleteTransactions,
  handleImportTransactions,
} from "./handlers/fileImport";
import { takeLatest, takeEvery } from "@redux-saga/core/effects";
import {
  ADD_CARD_TYPE,
  DELETE_CARD_TYPE,
  GET_ALL_CARD_TYPES,
  GET_AVAILABLE_CARD_TYPES,
  GET_CARD_TYPES,
  GET_CARD_TYPE_CONFIGURATIONS,
  UPDATE_CARD_TYPE_CONFIGURATIONS,
} from "../reducers/cardTypeReducer";
import {
  CHANGE_CARD,
  CHANGE_CARD_MODAL,
  DELETE_CARD,
  DELETE_CARD_MODAL,
  GET_ALL_CARDS_FOR_ID,
  GET_ALL_CARDS_FOR_PERSON,
  GET_CARDS_AS_PDF,
  GET_CARD_WITH_HISTORY_FOR_PERSON,
  GET_EXTENDED_CARD,
  GET_EXTENDED_CARD_FOR_PERSON,
  ORDER_CARD,
  REGISTER_CARD,
  REGISTER_CARD_MODAL,
  RESET_CARD,
} from "../reducers/cardReducer";
import {
  CREATE_REQUEST,
  GET_SESSION_TIME_OUT,
  GET_USER,
  LOGIN_MODAL,
  LOGIN_REQUEST,
  LOG_OUT,
  SAVE_URL_QUERY_STATE,
} from "../reducers/loginReducer";
import {
  CHANGE_CONSENT_MODAL,
  GET_GROUP_FOR_PERSON,
  GET_PERSON_CONSENT,
  GET_PERSON_NAME,
  GROUP_PERSON,
  REGISTER_OPT_OUT,
  SAVE_PERSON_CONSENT,
  UNGROUP_PERSON,
} from "../reducers/personReducer";
import {
  handleAddCardType,
  handleDeleteCardTypeModal,
  handleGetAvailableCardTypes,
  handleGetCardTypeConfigurations,
  handleGetCardTypes,
  handleUpdateCardTypes,
} from "./handlers/cardTypeSagas";
import {
  handleChangeCard,
  handleChangeCardModal,
  handleDeleteCard,
  handleDeleteCardModal,
  handleGetAllCardsForPerson,
  handleGetCardsAsPdf,
  handleGetCardsForId,
  handleGetCardWithHistoryForPerson,
  handleGetExtendedCard,
  handleGetExtendedCardForPerson,
  handleOrderCard,
  handleRegisterCard,
  handleRegisterCardModal,
  handleResetCard,
} from "./handlers/cardSagas";
import {
  handleGetPersonConsent,
  handleSavePersonConsent,
  handleRegisterOptOut,
  handleChangePersonConsentModal,
  handleGetGroupForPerson,
  handleGroupPerson,
  handleUnGroupPerson,
  handleGetPersonName,
} from "./handlers/personSagas";
import {
  handleAddTransactionModal,
  handleDeleteTransaction,
  handleDeleteTransactionModal,
  handleRegisterTransaction,
  handleRegisterTransactions,
  handleUpdateTransaction,
  handleUpdateTransactionModal,
} from "./handlers/transactionSagas";
import {
  REGISTER_TRANSACTION,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_MODAL,
  UPDATE_TRANSACTION,
  UPDATE_TRANSACTION_MODAL,
  REGISTER_TRANSACTIONS,
  ADD_TRANSACTION_MODAL,
} from "../reducers/transactionReducer";
import {
  handleCreateRequest,
  handleGetUser,
  handleLoginModal,
  handleLoginRequest,
  handleLogout,
  handleSessionTimeOut,
  handleURLQuery,
} from "./handlers/loginSagas";
import {
  GET_LOGS,
  GET_LOG_REPORT_AS_PDF,
  GET_LOG_REPORT_AS_XML,
} from "../reducers/logReducer";
import {
  handleGetLogReportAsPdf,
  handleGetLogReportAsXml,
  handleGetLogs,
} from "./handlers/logSagas";
import { GET_ACTION_TYPES } from "../reducers/actionTypeReducer";
import { handleGetActionTypes } from "./handlers/actionTypeSagas";
import {
  GET_FILES,
  GET_FILTER_TYPES,
  SET_IMPORT_CARDS,
  SET_IMPORT_DELETE_TRANSACTIONS,
  SET_IMPORT_TRANSACTIONS,
  SET_UPLOAD_FILE,
} from "../reducers/fileImportReducer";
import {
  handleAddCarePrincipal,
  handleAddCarePrincipalAccess,
  handleDeleteCarePrincipalAccess,
  handleDeleteCarePrincipalAccessModal,
  handleDeleteCarePrincipalModal,
  handleDeleteCareUnitSettings,
  handleGetAllCarePrincipals,
  // COMFACT - KOMMER ATT TAS BORT 
  // handleGetAllowedContracts,
  handleGetCarePrincipalAccess,
  handleGetCarePrincipalIdFromCurrentUser,
  handleGetCarePrincipalSettings,
  handleGetCareUnitSettings,
  handleGetConnectedCarePrincipals,
  handleGetJobsConfiguration,
  handleGetPuNames,
  handleGetSettingsFileNames,
  handleSaveCareUnitSettings,
  handleSaveSettingsFile,
  // COMFACT - KOMMER ATT TAS BORT 
  // handleUpdateAllowedContracts,
  handleUpdateCarePrincipal,
  handleUpdateCarePrincipalAccess,
  handleUpdateCarePrincipalAccessModal,
  handleUpdateCarePrincipalSettings,
  handleUpdateJobsConfiguration,
} from "./handlers/administrationSagas";
import {
  ADD_CAREPRINCIPAL,
  ADD_CARE_PRINCIPAL_ACCESS,
  DELETE_CAREPRINCIPAL,
  DELETE_CARE_PRINCIPAL_ACCESS,
  DELETE_CARE_PRINCIPAL_ACCESS_MODAL,
  DELETE_CARE_UNIT_SETTINGS,
  // COMFACT - KOMMER ATT TAS BORT 
  // GET_ALLOWED_CONTRACTS,
  GET_ALL_CAREPRINCIPALS,
  GET_CAREPRINCIPAL_SETTINGS,
  GET_CARE_PRINCIPAL_ACCESS,
  GET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER,
  GET_CARE_UNIT_SETTINGS,
  GET_CONNECTED_CAREPRINCIPALS,
  GET_JOBS_CONFIGURATIONS,
  GET_PU_NAMES,
  GET_SETTINGS_FILE_NAMES,
  SAVE_CAREPRINCIPAL,
  SAVE_CARE_UNIT_SETTINGS,
  SAVE_SETTINGS_FILE,
  // COMFACT - KOMMER ATT TAS BORT 
  // UPDATE_ALLOWED_CONTRACTS,
  UPDATE_CARE_PRINCIPAL_ACCESS,
  UPDATE_CARE_PRINCIPAL_ACCESS_MODAL,
  UPDATE_CARE_PRINCIPAL_SETTINGS,
  UPDATE_JOBS_CONFIGURATIONS,
} from "../reducers/administrationReducer";
import {
  GET_TRUSTS,
  DELETE_CA,
  SET_UPLOAD_CA,
  DELETE_CA_MODAL,
  GET_TRUST_HOLDERS,
  DELETE_TRUST_HOLDER,
  SET_UPLOAD_TRUST_HOLDER,
  DELETE_TRUST_HOLDER_MODAL,
  DOWNLOAD_CA,
} from "../reducers/trustManagerReducer";
import {
  handleAddCa,
  handleAddTrustHolder,
  handleDeleteCa,
  handleDeleteCaModal,
  handleDeleteTrustHolder,
  handleDeleteTrustHolderModal,
  handleDownloadCa,
  handleGetTrustHolders,
  handleGetTrusts,
} from "./handlers/trustManagerSagas";
import {
  ADD_GROUP,
  CHANGE_IDENTITY,
  DEL_GROUP,
  DEL_IDENTITY_CA,
  GET_GROUPS,
  GET_IDENTITY_CA,
} from "../reducers/keyStoreReducer";
import {
  handleAddIdentity,
  handleChangeIdentity,
  handleDeleteGroupModal,
  handleDeleteIdentityModal,
  handleDownloadIdentityCa,
  handleGetGroups,
} from "./handlers/keyStoreSagas";
import {
  handleDeleteWSClientModal,
  handleGetWSClients,
  handleSaveWSClient,
} from "./handlers/authorizationSaga";
import {
  DELETE_WS_CLIENT,
  GET_PRIVILEGE,
  GET_WS_CLIENTS,
  SAVE_PRIVILEGE,
  SAVE_WS_CLIENT,
} from "../reducers/authorizationReducer";
import { handleGetPrivilege, handleSavePrivilege } from "./handlers/rulesSaga";
import {
  handleGetSettings,
  handleGetSftpNames,
  handleGetSftpSettings,
  handlePutSftpSettings,
} from "./handlers/settingsSaga";
import {
  GET_SETTINGS,
  GET_SFTP_NAMES,
  GET_SFTP_SETTINGS,
  SAVE_SFTP_SETTINGS,
} from "../reducers/componentReducer";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // CREATE_CONTRACT,
  GET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT,
  // GET_CONTRACT,
  // GET_SIGNED_CONTRACT,
  // SIGN_CONTRACT,
} from "../reducers/contractReducer";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // handleCreateContract,
  handleGetAvailableCarePrincipals,
  // COMFACT - KOMMER ATT TAS BORT 
  //  handleGetContract,
  // handleGetSignedContract,
  // handleSignContract,
} from "./handlers/contractSaga";
import {
  GET_STATISTICS,
  GET_STATISTICS_CSV_FILE,
} from "../reducers/statisticsReducer";
import {
  handleGetStatistics,
  handleGetStatisticsCsvFile,
} from "./handlers/statisticsSaga";
import {
  DELETE_SYSTEM_STATUS_MESSAGE,
  GET_CURRENT_SYSTEM_STATUS_MESSAGES,
  GET_SYSTEM_STATUS_MESSAGES,
  SAVE_SYSTEM_STATUS_MESSAGE,
} from "../reducers/systemStatusMessageReducer";
import {
  handleDeleteSystemStatusMessageModal,
  handleGetAllSystemStatusMessages,
  handleGetCurrentSystemStatusMessagesForUser,
  handleSaveSystemStatusMessage,
} from "./handlers/systemStatusMessageSaga";
import {
  GET_LATEST_SUCCESSFUL_HSA_IMPORT,
  IMPORT_HSA_UNITS,
  SEARCH_HSA_UNITS,
} from "../reducers/hsaReducer";
import {
  handleGetLastSuccessfulImport,
  handleImportHSAUnits,
  handleSearchHSAUnits,
} from "./handlers/hsaSaga";
import { CALL_LOADING } from "../reducers/loadingReducer";
import handleLoading from "./handlers/loadingSaga";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // GET_ALL_ALLOWED_CONTRACTS,
  GET_ALL_CARD_TYPE_CONFIGURATIONS,
  GET_ALL_CARE_PRINCIPAL_ACCESS,
  GET_ALL_JOBS_CONFIGURATIONS,
} from "../reducers/infoReducer";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // handleGetAllAllowedContracts,
  handleGetAllCardTypeConfigurations,
  handleGetAllCarePrincipalAccess,
  handleGetAllJobsConfiguration,
} from "./handlers/infoSaga";

export function* watcherSaga() {
  yield takeLatest(CALL_LOADING, handleLoading);
  yield takeLatest(GET_STATISTICS, handleGetStatistics);
  yield takeEvery(GET_STATISTICS_CSV_FILE, handleGetStatisticsCsvFile);
  yield takeLatest(
    GET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT,
    handleGetAvailableCarePrincipals
  );
  yield takeLatest(GET_CAREPRINCIPAL_SETTINGS, handleGetCarePrincipalSettings);
  // COMFACT - KOMMER ATT TAS BORT 
  // yield takeLatest(CREATE_CONTRACT, handleCreateContract);
  // yield takeLatest(GET_CONTRACT, handleGetContract);
  // yield takeLatest(GET_SIGNED_CONTRACT, handleGetSignedContract);
  // yield takeLatest(SIGN_CONTRACT, handleSignContract);
  yield takeLatest(
    GET_CONNECTED_CAREPRINCIPALS,
    handleGetConnectedCarePrincipals
  );

  //Person
  yield takeEvery(GET_GROUP_FOR_PERSON, handleGetGroupForPerson);
  yield takeLatest(GROUP_PERSON, handleGroupPerson);
  yield takeLatest(UNGROUP_PERSON, handleUnGroupPerson);
  yield takeLatest(GET_PERSON_NAME, handleGetPersonName);

  //Login
  yield takeLatest(CREATE_REQUEST, handleCreateRequest);
  yield takeLatest(GET_SETTINGS, handleGetSettings);
  yield takeLatest(GET_USER, handleGetUser);
  yield takeLatest(LOG_OUT, handleLogout);
  yield takeLatest(GET_SESSION_TIME_OUT, handleSessionTimeOut);

  //Card
  yield takeLatest(
    GET_EXTENDED_CARD_FOR_PERSON,
    handleGetExtendedCardForPerson
  );
  yield takeLatest(SET_IMPORT_CARDS, handleImportCards);
  yield takeLatest(GET_EXTENDED_CARD, handleGetExtendedCard);
  yield takeLatest(
    GET_CARD_WITH_HISTORY_FOR_PERSON,
    handleGetCardWithHistoryForPerson
  );
  yield takeEvery(REGISTER_OPT_OUT, handleRegisterOptOut);
  yield takeEvery(GET_PERSON_CONSENT, handleGetPersonConsent);
  yield takeEvery(SAVE_PERSON_CONSENT, handleSavePersonConsent);
  yield takeEvery(LOGIN_MODAL, handleLoginModal);
  yield takeEvery(LOGIN_REQUEST, handleLoginRequest);
  yield takeEvery(REGISTER_CARD, handleRegisterCard);
  yield takeEvery(CHANGE_CARD, handleChangeCard);
  yield takeEvery(ORDER_CARD, handleOrderCard);
  yield takeEvery(GET_CARDS_AS_PDF, handleGetCardsAsPdf);

  //CardType
  yield takeEvery(GET_CARD_TYPES, handleGetCardTypes);
  yield takeEvery(GET_AVAILABLE_CARD_TYPES, handleGetAvailableCardTypes);

  //Logs
  yield takeEvery(GET_LOGS, handleGetLogs);
  yield takeEvery(GET_ACTION_TYPES, handleGetActionTypes);
  yield takeEvery(GET_LOG_REPORT_AS_PDF, handleGetLogReportAsPdf);
  yield takeEvery(GET_LOG_REPORT_AS_XML, handleGetLogReportAsXml);

  //CardAdmin
  yield takeLatest(GET_ALL_CARDS_FOR_PERSON, handleGetAllCardsForPerson);
  yield takeLatest(GET_ALL_CARDS_FOR_ID, handleGetCardsForId);
  yield takeLatest(RESET_CARD, handleResetCard);
  yield takeLatest(DELETE_CARD, handleDeleteCard);

  //CarePrincipal
  yield takeEvery(
    DELETE_CARE_PRINCIPAL_ACCESS,
    handleDeleteCarePrincipalAccess
  );
  yield takeEvery(GET_CARE_PRINCIPAL_ACCESS, handleGetCarePrincipalAccess);
  yield takeEvery(ADD_CARE_PRINCIPAL_ACCESS, handleAddCarePrincipalAccess);
  yield takeEvery(
    UPDATE_CARE_PRINCIPAL_ACCESS,
    handleUpdateCarePrincipalAccess
  );
  yield takeEvery(
    GET_CARD_TYPE_CONFIGURATIONS,
    handleGetCardTypeConfigurations
  );
  yield takeEvery(UPDATE_CARD_TYPE_CONFIGURATIONS, handleUpdateCardTypes);
  // COMFACT - KOMMER ATT TAS BORT 
  // yield takeEvery(GET_ALLOWED_CONTRACTS, handleGetAllowedContracts);
  // yield takeEvery(UPDATE_ALLOWED_CONTRACTS, handleUpdateAllowedContracts);
  yield takeEvery(GET_JOBS_CONFIGURATIONS, handleGetJobsConfiguration);
  yield takeEvery(UPDATE_JOBS_CONFIGURATIONS, handleUpdateJobsConfiguration);
  yield takeEvery(GET_PU_NAMES, handleGetPuNames);
  yield takeEvery(
    UPDATE_CARE_PRINCIPAL_SETTINGS,
    handleUpdateCarePrincipalSettings
  );
  yield takeEvery(SAVE_SETTINGS_FILE, handleSaveSettingsFile);
  yield takeEvery(GET_SETTINGS_FILE_NAMES, handleGetSettingsFileNames);
  yield takeEvery(
    GET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER,
    handleGetCarePrincipalIdFromCurrentUser
  );
  yield takeEvery(GET_CARE_UNIT_SETTINGS, handleGetCareUnitSettings);
  yield takeEvery(SAVE_CARE_UNIT_SETTINGS, handleSaveCareUnitSettings);
  yield takeEvery(DELETE_CARE_UNIT_SETTINGS, handleDeleteCareUnitSettings);

  //Transactions
  yield takeEvery(UPDATE_TRANSACTION, handleUpdateTransaction);
  yield takeEvery(REGISTER_TRANSACTION, handleRegisterTransaction);
  yield takeEvery(REGISTER_TRANSACTIONS, handleRegisterTransactions);
  yield takeEvery(DELETE_TRANSACTION, handleDeleteTransaction);
  yield takeLatest(SET_IMPORT_TRANSACTIONS, handleImportTransactions);
  yield takeLatest(
    SET_IMPORT_DELETE_TRANSACTIONS,
    handleImportDeleteTransactions
  );
  yield takeLatest(SEARCH_HSA_UNITS, handleSearchHSAUnits);
  yield takeLatest(
    GET_LATEST_SUCCESSFUL_HSA_IMPORT,
    handleGetLastSuccessfulImport
  );
  yield takeLatest(IMPORT_HSA_UNITS, handleImportHSAUnits);

  //URL-QUERY
  yield takeLatest(SAVE_URL_QUERY_STATE, handleURLQuery);

  //Modals
  yield takeEvery(
    DELETE_CARE_PRINCIPAL_ACCESS_MODAL,
    handleDeleteCarePrincipalAccessModal
  );
  yield takeEvery(
    UPDATE_CARE_PRINCIPAL_ACCESS_MODAL,
    handleUpdateCarePrincipalAccessModal
  );
  yield takeEvery(DELETE_TRANSACTION_MODAL, handleDeleteTransactionModal);
  yield takeEvery(UPDATE_TRANSACTION_MODAL, handleUpdateTransactionModal);
  yield takeEvery(REGISTER_CARD_MODAL, handleRegisterCardModal);
  yield takeEvery(CHANGE_CARD_MODAL, handleChangeCardModal);
  yield takeEvery(DELETE_CARD_MODAL, handleDeleteCardModal);
  yield takeEvery(CHANGE_CONSENT_MODAL, handleChangePersonConsentModal);
  yield takeEvery(ADD_TRANSACTION_MODAL, handleAddTransactionModal);
}

export function* administrationSagas() {
  //WS
  yield takeLatest(GET_WS_CLIENTS, handleGetWSClients);
  yield takeLatest(SAVE_WS_CLIENT, handleSaveWSClient);
  yield takeLatest(DELETE_WS_CLIENT, handleDeleteWSClientModal);

  //SETTINGS
  yield takeLatest(GET_SFTP_SETTINGS, handleGetSftpSettings);
  yield takeLatest(SAVE_SFTP_SETTINGS, handlePutSftpSettings);
  yield takeLatest(GET_SFTP_NAMES, handleGetSftpNames);

  //RULES
  yield takeLatest(GET_PRIVILEGE, handleGetPrivilege);
  yield takeLatest(SAVE_PRIVILEGE, handleSavePrivilege);

  //FILEIMPORT
  yield takeLatest(SET_UPLOAD_FILE, handleFileUpload);
  yield takeLatest(GET_FILES, handleGetFiles);
  yield takeLatest(GET_FILTER_TYPES, handleFilterTypes);

  //CA, TRUST and GROUPS
  yield takeLatest(GET_IDENTITY_CA, handleDownloadIdentityCa);
  yield takeLatest(CHANGE_IDENTITY, handleChangeIdentity);
  yield takeLatest(DEL_IDENTITY_CA, handleDeleteIdentityModal);
  yield takeLatest(ADD_GROUP, handleAddIdentity);
  yield takeLatest(DEL_GROUP, handleDeleteGroupModal);
  yield takeLatest(SET_UPLOAD_CA, handleAddCa);
  yield takeLatest(SET_UPLOAD_TRUST_HOLDER, handleAddTrustHolder);
  yield takeLatest(DELETE_CA, handleDeleteCa);
  yield takeLatest(DELETE_TRUST_HOLDER, handleDeleteTrustHolder);
  yield takeLatest(DELETE_TRUST_HOLDER_MODAL, handleDeleteTrustHolderModal);
  yield takeLatest(DELETE_CA_MODAL, handleDeleteCaModal);
  yield takeLatest(DOWNLOAD_CA, handleDownloadCa);
  yield takeLatest(GET_TRUST_HOLDERS, handleGetTrustHolders);
  yield takeLatest(GET_TRUSTS, handleGetTrusts);
  yield takeLatest(GET_GROUPS, handleGetGroups);

  yield takeLatest(SAVE_SYSTEM_STATUS_MESSAGE, handleSaveSystemStatusMessage);
  yield takeLatest(
    GET_SYSTEM_STATUS_MESSAGES,
    handleGetAllSystemStatusMessages
  );
  yield takeLatest(
    DELETE_SYSTEM_STATUS_MESSAGE,
    handleDeleteSystemStatusMessageModal
  );
  yield takeLatest(
    GET_CURRENT_SYSTEM_STATUS_MESSAGES,
    handleGetCurrentSystemStatusMessagesForUser
  );

  yield takeLatest(GET_ALL_CAREPRINCIPALS, handleGetAllCarePrincipals);
  yield takeLatest(SAVE_CAREPRINCIPAL, handleUpdateCarePrincipal);
  yield takeLatest(ADD_CAREPRINCIPAL, handleAddCarePrincipal);
  yield takeLatest(DELETE_CAREPRINCIPAL, handleDeleteCarePrincipalModal);
  yield takeLatest(GET_ALL_CARD_TYPES, handleGetCardTypes);
  yield takeLatest(DELETE_CARD_TYPE, handleDeleteCardTypeModal);
  yield takeLatest(ADD_CARD_TYPE, handleAddCardType);

  //INFO
  yield takeEvery(
    GET_ALL_CARD_TYPE_CONFIGURATIONS,
    handleGetAllCardTypeConfigurations
  );
  yield takeEvery(
    GET_ALL_CARE_PRINCIPAL_ACCESS,
    handleGetAllCarePrincipalAccess
  );
  // COMFACT - KOMMER ATT TAS BORT 
  // yield takeEvery(GET_ALL_ALLOWED_CONTRACTS, handleGetAllAllowedContracts);
  yield takeEvery(GET_ALL_JOBS_CONFIGURATIONS, handleGetAllJobsConfiguration);
}
